module.exports = __webpack_public_path__ + "static/media/Pablo - copia.539d8c1d.jpg";